<template>
  <div class="pin-page">
    <div class="pin-card">
      <h1>{{ title }}</h1>
      <p class="merchant">{{ rangeText }}</p>
      <label for="amount">支付金额（元）</label>
      <input
        id="amount"
        v-model="amount"
        type="text"
        inputmode="decimal"
        autocomplete="off"
        :placeholder="rangeText || '0.00'"
        :disabled="busy || !ready"
      />
      <p v-if="errorText" class="error">{{ errorText }}</p>
      <button type="button" class="pay" :disabled="busy || !ready" @click="pay">
        {{ busy ? '正在拉起支付…' : '去支付' }}
      </button>
    </div>
  </div>
</template>

<script>
import { executeDouyinzsPin, fetchDouyinzsPinPage } from '../api/api'

export default {
  data () {
    return {
      title: '抖音钻石',
      merchantName: '',
      minAmount: '',
      maxAmount: '',
      amount: '',
      errorText: '',
      busy: false,
      ready: false
    }
  },
  computed: {
    rangeText () {
      if (!this.minAmount || !this.maxAmount) return ''
      return '支付金额 ' + this.minAmount + '-' + this.maxAmount
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    toFen (raw) {
      const text = String(raw || '').trim()
      if (!/^\d+(\.\d{1,2})?$/.test(text)) return null
      const parts = text.split('.')
      const frac = (parts[1] || '').padEnd(2, '0')
      const fen = Number(parts[0]) * 100 + Number(frac)
      if (!isFinite(fen) || fen <= 0) return null
      return fen
    },
    token () {
      return (this.$route.params && this.$route.params.token) || ''
    },
    load () {
      const token = this.token()
      if (!token) {
        this.errorText = '置顶码无效'
        return
      }
      fetchDouyinzsPinPage(token).then(data => {
        this.title = (data && data.title) || '抖音钻石'
        this.merchantName = (data && data.merchantName) || ''
        this.minAmount = (data && data.minAmount) || ''
        this.maxAmount = (data && data.maxAmount) || ''
        if (!this.minAmount || !this.maxAmount) {
          this.errorText = '置顶码未设置金额范围'
          return
        }
        this.ready = true
      }).catch(err => {
        this.errorText = (err && err.message) || '置顶码无效'
      })
    },
    pay () {
      if (this.busy || !this.ready) return
      const amount = (this.amount || '').trim()
      const fen = this.toFen(amount)
      const minFen = this.toFen(this.minAmount)
      const maxFen = this.toFen(this.maxAmount)
      if (fen == null) {
        this.errorText = '请输入金额'
        return
      }
      if (minFen == null || maxFen == null || fen < minFen || fen > maxFen) {
        this.errorText = '支付金额需在 ' + this.minAmount + '-' + this.maxAmount + ' 之间'
        return
      }
      this.busy = true
      this.errorText = ''
      executeDouyinzsPin(this.token(), amount).then(data => {
        const payUrl = data && data.payUrl
        if (!payUrl) {
          this.busy = false
          this.errorText = '未返回支付链接'
          return
        }
        window.location.replace(payUrl)
      }).catch(err => {
        this.busy = false
        this.errorText = (err && err.message) || '拉起支付失败'
      })
    }
  }
}
</script>

<style scoped>
.pin-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px 16px;
  background: #f5f7fa;
}
.pin-card {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 24px 16px 20px;
  box-sizing: border-box;
}
h1 {
  margin: 0;
  font-size: 22px;
  text-align: center;
  color: #303133;
}
.merchant {
  min-height: 22px;
  margin: 8px 0 20px;
  text-align: center;
  color: #606266;
}
label {
  display: block;
  margin-bottom: 8px;
  color: #606266;
}
input {
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 18px;
}
.error {
  margin: 10px 0 0;
  color: #f56c6c;
  font-size: 14px;
}
.pay {
  width: 100%;
  height: 44px;
  margin-top: 16px;
  border: 0;
  border-radius: 6px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
}
.pay:disabled {
  opacity: 0.65;
}
</style>
